import { Component, HostListener, inject, Input } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { LayoutComponent } from '../../../../core/layout/layout.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AgGridAngular } from 'ag-grid-angular';
import { ColDef } from 'ag-grid-community';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { AttendanceService } from '../../../../features/attendance/services/attendance.service';
import { ToastrService } from 'ngx-toastr';
import { DialogRef } from '@angular/cdk/dialog';
import { EmployeeService } from '../../../../features/employees/employee.service';
import * as Papa from 'papaparse';
import { FormArray, FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ImageService } from '../../../../shared/services/image.service';
import { HolidayCalendarService } from '../../../../features/holiday-calendar/services/holiday-calendar.service';
import { DateAdapter, MatNativeDateModule, NativeDateAdapter } from '@angular/material/core';
import { MAT_DATE_FORMATS } from '@angular/material/core';
// import { PermissionDirective } from '../../../../shared/directives/permissions.directive';
// import { Permission } from '../../../../shared/services/permissions';
import { MatTabChangeEvent, MatTabGroup, MatTabsModule } from '@angular/material/tabs';
import { HttpClient } from '@angular/common/http';
import { Apollo, gql } from 'apollo-angular';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatIconModule } from '@angular/material/icon';
import { FormatTimePipe } from '../../../../shared/pipes/format-time.pipe';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { ProjectService } from '../../../../features/projects/services/projects.service';
import { debounceTime, distinctUntilChanged } from 'rxjs';
import { ModuleIds } from '../../../../shared/permission-constants/permission-const';
import { PermissionService } from '../../../../shared/services/permission.service';

export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY', // Define the format for parsing
  },
  display: {
    dateInput: 'DD/MM/YYYY', // Define the format for display
    monthYearLabel: 'MMM YYYY', // Format for month/year picker
    dateA11yLabel: 'DD/MM/YYYY', // Accessibility label
    monthDayA11yLabel: 'DD MMM', // Month/day a11y label
  },
};

@Component({
  selector: 'app-attendance',
  standalone: true,
  imports: [
    LayoutComponent,
    CommonModule,
    MatDatepickerModule,
    MatInputModule,
    MatFormFieldModule,
    AgGridAngular,
    ReactiveFormsModule,
    FormsModule,
    MatNativeDateModule,
    MatSelectModule,
    // PermissionDirective,
    MatTabGroup,
    MatTabsModule,
  ],
  templateUrl: './attendance.component.html',
  styleUrl: './attendance.component.scss',
  // providers: [FormatTimePipe]
  providers: [
    FormatTimePipe,
    {
      provide: MAT_DATE_FORMATS,
      useValue: MY_DATE_FORMATS, // Use the custom format
    }
  ],
})
export class AttendanceComponent {
  public viewPortSize: boolean = false;
  public limit: number = 10;
  public paginationPageSizeSelector: number[] | boolean = [10, 25, 50];
  offset: number = 1;
  search: string = '';
  filter: any;
  isDropdownOpen = false;
  startDate: any;
  endDate: any;
  employeeTypes: any;
  employeeStatus: any;
  selectedEmployeeTypes: any;
  selectedEmployeeStatus: any;
  filterForm: FormGroup;
  dateRangeForm: FormGroup;
  employees: any;  // Permission = Permission;
  employeeSearchControl = new FormControl();
  public rowData: any[] | null = null;
  // @Input() isManagement: boolean = false;
  columnDefs: ({ headerName: string; field: string; flex: number; cellRenderer: (params: any) => string; } | { headerName: string; field: string; flex: number; cellRenderer?: undefined; })[];
  // today: Date = new Date();

  // dateFilter = (d: Date | null): boolean => {
  //   const currentDate = d || new Date();
  //   return currentDate <= this.today
  // };
  canListAttendance$ = this.permissionService.hasPermission(
    ModuleIds.Attendance,
    'List'
  );

  dateFilter = (date: Date | null): boolean => {
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Remove time component
    return date ? date <= today : false;
  };

  constructor(
    private attendanceService: AttendanceService,
    private employeeService: EmployeeService,
    private projectService: ProjectService,
    private toastr: ToastrService,
    private datePipe: DatePipe,
    private formatTimePipe: FormatTimePipe,
    private fb: FormBuilder,
    private imageService: ImageService,
    private http: HttpClient,
    private apollo: Apollo,
    private permissionService: PermissionService
  ) {
    this.filterForm = this.fb.group({
      employeeTypes: this.fb.array([]),
      employeeStatus: this.fb.array([]),
    });


  }

  ngOnInit() {
    // Set default dates to current date
    const currentDate = new Date();
    const formatDate = (date: Date) => {
      return date.toLocaleDateString('en-CA');
    };

    // Initialize filter with current date for both start and end
    this.filter = {
      dateRange: {
        startDate: formatDate(currentDate),
        endDate: formatDate(currentDate)
      },
      // isVerified: true
      // isVerified: !this.isManagement,
    }

    // Initialize the date range form with current date
    this.dateRangeForm = this.fb.group({
      startDate: [currentDate],
      endDate: [currentDate],
      employeeId: [null]
    });

    this.employeeSearchControl.valueChanges
    .pipe(debounceTime(300), distinctUntilChanged())
    .subscribe((searchText) => {
      this.fetchAttendance(searchText);
    });

    // Set the startDate and endDate properties for consistency
    this.startDate = this.filter.dateRange.startDate;
    this.endDate = this.filter.dateRange.endDate;

    this.fetchAttendance();
    this.loadEmployeeTypes();
    this.loadEmployeeStatus();
    this.checkViewportSize();
  }

  toggleDropdown(event?: MouseEvent) {
    if (event) {
      event.stopPropagation();
    }
    this.isDropdownOpen = !this.isDropdownOpen;
  }


  openDialog() {
    const dialogRef = this.dialog.open(UploadAttendanceDialog, {
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.fetchAttendance();
    });
  }

  openOfflineDialog() {
    const dialogRef = this.dialog.open(OfflineAttendanceDialog, {
      width: '500px',
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.toastr.success('Offline attendance processing completed');
      }
    });
  }

  readonly dialog = inject(MatDialog);

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkViewportSize();
  }

  checkViewportSize() {
    if (window.innerWidth > 1200) {
      this.viewPortSize = true;
    } else {
      this.viewPortSize = false;
    }
    this.setAGColumn();
  }

  setAGColumn() {

    this.columnDefs = [
      {
        headerName: 'Employee Name',
        field: 'name',
        flex: this.viewPortSize ? 1 : 0,
        cellRenderer: (params: any) => {
          return `
          <div style="display: flex; align-items: center;">
            <img src="${params.data.imageUrl}" alt="Profile Image" style="width: 35px; height: 35px; margin-right: 10px; border-radius: 50%; object-fit: cover;">
            <div>
              <span>${params.data.name}</span>
            </div>
          </div>
        `;
        }
      },
      { headerName: 'Date', field: 'date', flex: this.viewPortSize ? 1 : 0 },
      { headerName: 'Designation', field: 'designation', flex: this.viewPortSize ? 1 : 0 },
      { headerName: 'Employee Code', field: 'employeeCode', flex: this.viewPortSize ? 1 : 0 },
      { headerName: 'Check In', field: 'in', flex: this.viewPortSize ? 1 : 0 },
      { headerName: 'Check Out', field: 'out', flex: this.viewPortSize ? 1 : 0 },
      { headerName: 'Work Hrs', field: 'hrs', flex: this.viewPortSize ? 1 : 0 },
      { headerName: 'Overtime', field: 'overtime', flex: this.viewPortSize ? 1 : 0 },
      { headerName: 'Type', field: 'type', flex: this.viewPortSize ? 1 : 0 },
      {
        headerName: 'Status',
        field: 'status',
        flex: this.viewPortSize ? 1 : 0,
        cellRenderer: (params: any) => {
          const status = params.data.status;
          const statusClass = status === "On Leave" ? 'on-leave' : 'working'; // Apply class if "On Leave"
          return `<span class="${statusClass}">${status}</span>`;
        }
      },
    ];
  }

  public defaultColDef: ColDef = {
    filter: 'agTextColumnFilter',
    floatingFilter: true,
  };
  public rowSelection: 'single' | 'multiple' = 'multiple';
  public themeClass: string = 'ag-theme-quartz';

  get employeeTypesFormArray() {
    return this.filterForm.get('employeeTypes') as FormArray;
  }

  // Getter for employeeStatus form array
  get employeeStatusFormArray() {
    return this.filterForm.get('employeeStatus') as FormArray;
  }

  fetchAttendance(customFilter: any = null, isFallback: boolean = false) {
    // this.filter = customFilter ? { ...this.filter, ...customFilter } : this.filter;

    // If this is a fallback call, adjust the end date to +1 day
    let adjustedFilter = this.filter;
    if (isFallback) {
      const startDate = this.startDate || this.filter.dateRange.startDate;
      const endDate = this.endDate || this.filter.dateRange.endDate;
      
      const endDateObj = new Date(endDate);
      endDateObj.setDate(endDateObj.getDate() + 1);
      const adjustedEndDate = endDateObj.toLocaleDateString('en-CA');
      
      adjustedFilter = {
        ...this.filter,
        dateRange: {
          startDate: startDate,
          endDate: adjustedEndDate
        }
      };
    }

    this.attendanceService.fetchAttendance(this.search, adjustedFilter).subscribe({
      next: async (data) => {
        this.rowData = await Promise.all(
          data.map(async (item: any) => {
            let profilePicture;
            console.log("profilePicture", profilePicture);
            if (item?.employee?.profilePicture) {
              try {
                profilePicture = await this.imageService.getImageAsBase64(
                  item?.employee.profilePicture
                );
              } catch (error) {
                profilePicture = 'assets/images/dummy-profile-image.jpg';
              }
            } else {
              profilePicture = 'assets/images/dummy-profile-image.jpg';
            }
            return {
              date: this.datePipe.transform(item?.date, 'dd/MM/yyyy') || '--',
              name: item?.employee?.firstName + ' ' + item?.employee?.lastName || '--',
              designation: item?.employee?.designation?.designationName || '--',
              imageUrl: profilePicture,
              id: item?.employeeId || '--',
              employeeCode: item?.employee?.employeeCode || '--',
              in: this.formatTimePipe.transform(item?.checkInTime) || '--',
              out: this.formatTimePipe.transform(item?.checkOutTime) || '--',
              // hrs: item?.totalHoursWorked != null
              //   ? (item?.totalHoursWorked < 1
              //     ? `${Math.round(item?.totalHoursWorked * 60)} mins`
              //     : `${item?.totalHoursWorked} Hrs`)
              //   : '--',
              hrs: item?.totalHoursWorked != null
                ? this.formatHours(item?.totalHoursWorked) : '--',
              overtime:  item?.overtimeHours != null
              ? this.formatHours(item?.overtimeHours) : '--',
              type: item?.employee?.employeeType || '--',
              status: item?.employee?.employeeStatus || '--',
            };
          })
        );
        
        // If no data found and this is not already a fallback call, try with end date + 1 day
        if (data.length === 0 && !isFallback && this.startDate === this.endDate) {
          console.log('No data found for same date, trying with end date + 1 day');
          this.fetchAttendance(customFilter, true);
        }
      },
      error: (error) => {
        this.toastr.error(error?.message);
      },
    });
  }

  formatHours(decimalHours: number): string {
    const hours = Math.floor(decimalHours);
    const minutes = Math.round((decimalHours - hours) * 60);
    return `${hours.toString().padStart(2, '0')} Hrs ${minutes.toString().padStart(2, '0')} Min`;
  }

  loadEmployeeTypes() {
      this.projectService.getAllEmployees('').subscribe({
  
        next: (employeeTypes) => {
          this.employees = employeeTypes;
        },
        error: (error) => console.error('Error fetching employee types:', error),
      });
  }


  onClear() {
    // this.search ``= '';
    this.filter = {};
    this.dateRangeForm.reset();
    this.fetchAttendance();
  }
  onEmployeeChange(event: MatSelectChange) {
    const employee = event.value;
    this.filter = { employeeId: employee };
    this.fetchAttendance(this.filter);
  }

  private addControls(formArrayName: string, data: any[]) {
    const formArray = this.filterForm.get(formArrayName) as FormArray;
    formArray.clear();

    data.forEach(() => {
      formArray.push(new FormControl(false));
    });
  }

  loadEmployeeStatus() {
    this.employeeService.getEmployeeStatus().subscribe({
      next: (data) => {
        this.employeeStatus = data;
        this.addControls('employeeStatus', this.employeeStatus);
      },
      error: (error) => {
        this.toastr.error(error?.message);
      }
    });
  }

  findAllAttendancesWithPagination() {
    if (this.offset < 0) {
      this.offset = 0;
    }
    this.attendanceService.findAllAttendancesWithPagination(this.limit, this.offset, this.search, this.filter).subscribe({
      next: (data) => {
        this.rowData = data?.attendances
          .map((data: any) => {
            const workHrs = data?.totalHoursWorked || 0;
            const hrs =
              workHrs < 1
                ? `${Math.round(workHrs * 60)} mins`
                : `${workHrs} Hrs`;

            return {
              date: this.datePipe.transform(data?.date, 'dd/MM/yyyy') || '--',
              name: data?.employee?.firstName + ' ' + data?.employee?.lastName || '--',
              designation: data?.designation || '--',
              imageUrl: data?.employee?.profilePicture || '--',
              id: data?.employeeId || '--',
              in: this.formatTimePipe.transform(data?.checkInTime) || '--',
              out: this.formatTimePipe.transform(data?.checkOutTime) || '--',
              hrs: hrs,
              overtime: data?.overtimeHours + ' ' + 'Hrs' || '--',
              type: data?.employee?.employeeType || '--',
              status: data?.employee?.employeeStatus || '--',
            };
          });
      },
      error: (error) => {
        this.toastr.error(error?.message);
      },
    });
  }

  onSubmit() {
    const selectedEmployeeStatus = this.filterForm.value.employeeStatus
      .map((checked: boolean, i: number) =>
        checked ? this.employeeStatus[i].employeeStatus : null
      )
      .filter((value: string | null) => value !== null);

    const selectedEmployeeTypes = this.filterForm.value.employeeTypes
      .map((checked: boolean, i: number) =>
        checked ? this.employeeTypes[i].employeeType : null
      )
      .filter((value: string | null) => value !== null);

    const startDate = new Date();
    const endDate = new Date();
    const formatDate = (date: Date) => {
      return date.toLocaleDateString('en-CA');
    };
    if (!this.startDate && !this.endDate) {
      this.startDate = formatDate(startDate);
      this.endDate = formatDate(endDate);
    }

    console.log(selectedEmployeeStatus);


    this.filter = {
      dateRange: { startDate: this.startDate, endDate: this.endDate },
      employeeStatus: selectedEmployeeStatus,
      employeeType: selectedEmployeeTypes,
      // isVerified: !this.isManagement,
    }
    this.fetchAttendance();
    this.toggleDropdown();
  }

  onDateChange(event: any, type: string) {
    if (event.value) {
      const formattedDate = this.datePipe.transform(event.value, 'yyyy-MM-dd');
      if (type === 'start') {
        this.startDate = formattedDate;
      } else if (type === 'end') {
        this.endDate = formattedDate;
      }
      
      // Only proceed if both dates are set
      if (this.startDate != null && this.endDate != null) {
        this.filter = { dateRange: { startDate: this.startDate, endDate: this.endDate } };
        this.fetchAttendance();
      }
    }
  }

  clearFilter() {
    this.filterForm.reset();
  }

  onSearch(event: Event) {
    const input = event.target as HTMLInputElement;
    this.search = input.value;
    this.fetchAttendance();
  }

  onPaginationChanged(event: any): void {

    const currentPage = event.api.paginationGetCurrentPage();
    // this.limit = event.api.paginationGetPageSize(); 
    // this.offset = currentPage * this.limit;
    // if (this.offset < 0) {
    //   this.offset = 0;
    // }
    // this.findAllAttendancesWithPagination();
  }
}




@Component({
  selector: 'upload-attendance-dialog',
  templateUrl: 'upload-attendance-dialog.html',
  styleUrl: './attendance.component.scss',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatDatepickerModule,
    MatInputModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    FormsModule
  ],
  providers: [FormatTimePipe]
})
export class UploadAttendanceDialog {
  csvFile: any = null;
  url: any;
  selectedDate: any;
  search: string | undefined;
  filter: {};
  uploadForm: FormGroup;
  today: Date = new Date();
  holidays: any;


  dateFilter = (d: Date | null): boolean => {
    this.fetchHolidays();

    const currentDate = d || new Date();
    if (!this.holidays || this.holidays.length === 0) {
      return currentDate <= this.today;
    }

    const isHoliday = this.holidays.some(
      (holidayDate: Date) => holidayDate.getTime() === currentDate.getTime()
    );

    return currentDate <= this.today && !isHoliday;
  };

  constructor(
    private toastr: ToastrService,
    private datePipe: DatePipe,
    private attendanceService: AttendanceService,
    private dialogRef: DialogRef,
    private formatTimePipe: FormatTimePipe,
    private fb: FormBuilder,
    private holidayService: HolidayCalendarService,
  ) { }

  ngOnInit() {
    this.uploadForm = this.fb.group({
      date: [this.today, Validators.required],
      file: ['', Validators.required],
    });
    this.selectedDate = this.datePipe.transform(this.today, 'yyyy-MM-dd');
    document.addEventListener('dragover', this.preventDefaultBehavior);
    document.addEventListener('drop', this.preventDefaultBehavior);
    this.fetchHolidays();
  }

  preventDefaultBehavior(event: DragEvent) {
    event.preventDefault();
  }

  onDateChange(event: any) {
    this.selectedDate = this.datePipe.transform(event.value, 'yyyy-MM-dd');
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
  }

  onDrop(event: DragEvent) {
    event.preventDefault();

    if (event.dataTransfer?.files.length) {
      this.onFileSelected({ target: { files: event.dataTransfer.files } });
    }
  }


  onFileSelected(event: any): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      this.csvFile = file;
    }
  }

  fetchAttendance() {
    this.attendanceService.fetchAttendance(this.search, this.filter).subscribe({
      next: (data) => {
        data
          .map((data: any) => {
            return {
              name: data?.employee?.firstName + ' ' + data?.employee?.lastName || '--',
              designation: data?.designation || '--',
              imageUrl: data?.employee?.profilePicture || '--',
              id: data?.employeeId || '--',
              in: this.formatTimePipe.transform(data?.checkInTime) || '--',
              out: this.formatTimePipe.transform(data?.checkOutTime) || '--',
              hrs: data?.totalHoursWorked + ' ' + 'Hrs' || '--',
              overtime: data?.overtimeHours + ' ' + 'Hrs' || '--',
              type: data?.employee?.employeeType || '--',
              status: data?.employee?.employeeStatus || '--',
            };
          });
      },
      error: (error) => {
        this.toastr.error(error?.message);
      },
    });
  }

  uploadDocuments(csvFile: any, selectedDate: any) {
    const reader = new FileReader();

    reader.readAsText(csvFile);
    reader.onload = () => {
      const csvData = reader.result as string;
      Papa.parse(csvData, {
        header: true,
        complete: (parsedData) => {
          const rows = parsedData.data;
          const modifiedRows = rows.map((row: any) => {
            row['date'] = selectedDate;
            return row;
          });

          const modifiedCsv = Papa.unparse(modifiedRows);

          // Create a Blob for the new CSV file
          const modifiedBlob = new Blob([modifiedCsv], { type: 'text/csv' });
          const modifiedFile = new File([modifiedBlob], csvFile.name, { type: 'text/csv' });
          console.log(modifiedCsv);

          this.attendanceService.bulkCreateAttendance(modifiedFile).subscribe({
            next: (response) => {
              console.log(response);

              if (response && !response.errors) {
                this.toastr.success('Attendance uploaded successfully!', 'Success');
                this.dialogRef.close();
              }
              else if (response?.errors) {
                this.toastr.error(response?.errors[0]?.message, 'Error');
              }
            },
            error: (error) => {
              this.toastr.error(error, 'Bulk attendance creation failed');
              this.dialogRef.close();
            },
          });
        },
        error: (error: any) => {
          this.toastr.error(error.message, 'Error parsing CSV file');
        }
      });
    };
    reader.onerror = (error) => {
      this.toastr.error('Error reading file');
    };
  }

  fetchHolidays() {
    this.holidayService.getHolidayCalendarList().subscribe({
      next: (data) => {
        this.holidays = data.map((holiday: any) => new Date(holiday.holidayDate));
      },
      error: (error) => {
        console.error(error, 'Error');
      }
    })
  }


  onUpdate() {
    if (this.uploadForm.invalid && !this.csvFile) {
      this.uploadForm.markAllAsTouched();
      return;
    }
    if (this.csvFile && this.selectedDate) {
      this.uploadDocuments(this.csvFile, this.selectedDate);
    }
  }

  removeFile(): void {
    this.csvFile = null;
    const input = document.querySelector('input[type="file"]') as HTMLInputElement;
    if (input) {
      input.value = '';
    }
  }

  ngOnDestroy() {
    document.removeEventListener('dragover', this.preventDefaultBehavior);
    document.removeEventListener('drop', this.preventDefaultBehavior);
  }
}

// Offline Attendance Dialog Component
@Component({
  selector: 'app-offline-attendance-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    ReactiveFormsModule,
    FormsModule,
    MatIconModule,
    MatProgressBarModule
  ],
  template: `
    <div class="dialog-container">
      <h2 mat-dialog-title>Mark Offline Attendance</h2>
      <mat-dialog-content><br/>
        
        <form [formGroup]="dateRangeForm">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Start Date</mat-label>
            <input matInput [matDatepicker]="startPicker" formControlName="startDate" required>
            <mat-datepicker-toggle matIconSuffix [for]="startPicker"></mat-datepicker-toggle>
            <mat-datepicker #startPicker></mat-datepicker>
          </mat-form-field>
          
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>End Date</mat-label>
            <input matInput [matDatepicker]="endPicker" formControlName="endDate" required>
            <mat-datepicker-toggle matIconSuffix [for]="endPicker"></mat-datepicker-toggle>
            <mat-datepicker #endPicker></mat-datepicker>
          </mat-form-field>
        </form>

        <div class="sync-success" *ngIf="hasSyncedData">
          <p *ngIf="totalRecords > 0">✅ Successfully synced {{ totalRecords }} offline records</p>
          <p *ngIf="totalRecords === 0">ℹ️ No offline records found for the selected date range</p>
        </div>

        <div class="progress-section" *ngIf="isProcessing">
          <div class="progress-info">
            <p>Processing offline attendance records...</p>
            <p>Found {{ totalRecords }} records, processed {{ processedRecords }}</p>
          </div>
          <mat-progress-bar mode="determinate" [value]="progressPercentage"></mat-progress-bar>
        </div>
      </mat-dialog-content>
      
      <mat-dialog-actions align="end">
        <button mat-button mat-dialog-close [disabled]="isProcessing">Cancel</button>
        <button mat-raised-button color="primary" (click)="syncOfflineData()" 
                *ngIf="dateRangeForm.valid && !hasSyncedData"
                [disabled]="isSyncing">
          {{ isSyncing ? 'Syncing...' : 'Sync Data' }}
        </button>
        <button mat-raised-button color="primary" (click)="markAttendance()" 
                *ngIf="hasSyncedData && totalRecords > 0"
                [disabled]="isProcessing">
          {{ isProcessing ? 'Processing...' : 'Mark Attendance' }}
        </button>
      </mat-dialog-actions>
    </div>
  `,
  styles: [`
    .dialog-container {
      padding: 20px;
    }
    .info-section {
      margin-bottom: 20px;
      padding: 15px;
      background-color: #f5f5f5;
      border-radius: 5px;
    }
    .full-width {
      width: 100%;
      margin-bottom: 15px;
    }
    .sync-section {
      margin: 20px 0;
      text-align: center;
    }
    .progress-section {
      margin: 20px 0;
    }
    .progress-info {
      margin-bottom: 10px;
    }
    .progress-info p {
      margin: 5px 0;
      font-size: 14px;
    }
    .sync-success {
      margin: 20px 0;
      padding: 15px;
      background-color: #d4edda;
      border: 1px solid #c3e6cb;
      border-radius: 5px;
      color: #155724;
    }
    .sync-success p {
      margin: 0;
      font-weight: 500;
    }
  `]
})
export class OfflineAttendanceDialog {
  dateRangeForm: FormGroup;
  isSyncing: boolean = false;
  isProcessing: boolean = false;
  hasSyncedData: boolean = false;
  offlineLogs: any[] = [];
  totalRecords: number = 0;
  processedRecords: number = 0;
  progressPercentage: number = 0;

  constructor(
    private dialogRef: DialogRef,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private http: HttpClient,
    private apollo: Apollo,
    private datePipe: DatePipe
  ) {
    this.dateRangeForm = this.fb.group({
      startDate: ['', Validators.required],
      endDate: ['', Validators.required]
    });

    // Reset sync state when date range changes
    this.dateRangeForm.valueChanges.subscribe(() => {
      if (this.hasSyncedData) {
        this.hasSyncedData = false;
        this.offlineLogs = [];
        this.totalRecords = 0;
      }
    });
  }

  syncOfflineData() {
    if (this.dateRangeForm.valid) {
      this.isSyncing = true;
      
      const startDate = this.dateRangeForm.get('startDate')?.value;
      const endDate = this.dateRangeForm.get('endDate')?.value;
      
      const formattedStartDate = this.datePipe.transform(startDate, 'yyyy-MM-dd');
      const formattedEndDate = this.datePipe.transform(endDate, 'yyyy-MM-dd');

      const url = `https://face-recog.munawelconnect.com/api/match-logs?startDate=${formattedStartDate}&endDate=${formattedEndDate}`;

      this.http.get(url).subscribe({
        next: (response: any) => {
          this.isSyncing = false;
          
          // Filter only offline records
          this.offlineLogs = response.logs.filter((log: any) => log.sessionId === 'offline');
          this.totalRecords = this.offlineLogs.length;
          this.hasSyncedData = true;
          
          console.log('Offline logs fetched:', this.offlineLogs);
          this.toastr.success(`Found ${this.totalRecords} offline attendance records`);
        },
        error: (error: any) => {
          this.isSyncing = false;
          console.error('Error fetching offline attendance:', error);
          this.toastr.error('Error fetching offline attendance data');
        }
      });
    }
  }

  markAttendance() {
    if (this.offlineLogs.length === 0) {
      this.toastr.error('No offline records to process');
      return;
    }

    this.isProcessing = true;
    this.processedRecords = 0;
    this.progressPercentage = 0;

    // Process records in batches to avoid overwhelming the server
    const batchSize = 5;
    const processBatch = (startIndex: number) => {
      const endIndex = Math.min(startIndex + batchSize, this.offlineLogs.length);
      const batch = this.offlineLogs.slice(startIndex, endIndex);

      const promises = batch.map((log: any) => {
        if (!log.photoCreatedDate) {
          this.processedRecords++;
          return Promise.resolve();
        }

        const attendanceData = {
          empId: log.empCode,
          time: this.extractTimeFromDate(log.photoCreatedDate),
          date: this.extractDateFromDate(log.photoCreatedDate),
          androidId: "offline-system",
          latitude: "24.8248467",
          longitude: "55.107071",
          locationId: 1
        };

        return this.recordAttendanceMutation(attendanceData);
      });

      Promise.all(promises).then(() => {
        this.processedRecords += batch.length;
        this.progressPercentage = (this.processedRecords / this.totalRecords) * 100;

        if (endIndex < this.offlineLogs.length) {
          // Process next batch after a short delay
          setTimeout(() => processBatch(endIndex), 1000);
        } else {
          // All records processed
          this.isProcessing = false;
          this.toastr.success(`Successfully processed ${this.processedRecords} offline attendance records`);
          this.dialogRef.close(true);
        }
      }).catch((error) => {
        console.error('Error processing batch:', error);
        this.isProcessing = false;
        this.toastr.error('Error processing some attendance records');
      });
    };

    // Start processing
    processBatch(0);
  }

  extractTimeFromDate(dateString: string): string {
    const date = new Date(dateString);
    return date.toTimeString().slice(0, 5); // HH:mm format
  }

  extractDateFromDate(dateString: string): string {
    const date = new Date(dateString);
    return date.toISOString().split('T')[0]; // YYYY-MM-DD format
  }

  recordAttendanceMutation(attendanceData: any) {
    const mutation = `
      mutation RecordAttendance($createAttendanceInput: CreateEmployeeAttendanceInput!) {
        recordAttendance(createAttendanceInput: $createAttendanceInput) {
          id
          empId
          date
          androidId
          latitude
          longitude
          locationId
        }
      }
    `;

    return this.apollo.use('hrms').mutate({
      mutation: gql`${mutation}`,
      variables: {
        createAttendanceInput: attendanceData
      }
    }).toPromise();
  }
}
